import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { getPortalState } from '../../lib/portalDomain'
import { requestPortalSessionReset } from '../redux/features/portal-session-reset/portalSessionResetSlice'
import { useAuthLogoutMutation } from '../redux/api/web-api'
import { triggerAuthChange } from '../utils/broadcastChannel'

// Roll back a partially established portal session without using the full sign-out redirect flow.
export const useRejectedPortalLoginCleanup = () => {
    const dispatch = useDispatch()
    const portal = getPortalState(window.location.pathname)
    const [logout] = useAuthLogoutMutation()

    return useCallback(
        async ({ broadcastAuthChange = true }: { broadcastAuthChange?: boolean } = {}): Promise<void> => {
            if (portal.isPortalDomain) {
                try {
                    await logout().unwrap()
                } catch {
                    // Clear local state even if backend logout fails or the session is already gone.
                }
            }

            dispatch(requestPortalSessionReset())
            if (broadcastAuthChange) {
                triggerAuthChange()
            }
        },
        [dispatch, logout, portal.isPortalDomain]
    )
}
